<div class="title-section">
  <h3 id="{{id}}" class="title">{{ title }}</h3>
  <div class="title-line"></div>
</div>